module.exports = __webpack_public_path__ + "fonts/Manrope-700-cyrillic20.765433f.woff2";